var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5F9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 29H26.1183V26.4286C26.1168 25.103 25.5895 23.8321 24.6522 22.8947C23.7148 21.9574 22.4439 21.4301 21.1183 21.4286H19C17.6744 21.4301 16.4035 21.9574 15.4661 22.8947C14.5288 23.8321 14.0015 25.103 14 26.4286V29ZM15.1429 15C15.1429 15.9889 15.4361 16.9556 15.9855 17.7779C16.5349 18.6001 17.3158 19.241 18.2294 19.6194C19.1431 19.9978 20.1484 20.0969 21.1183 19.9039C22.0882 19.711 22.9791 19.2348 23.6784 18.5355C24.3777 17.8363 24.8539 16.9454 25.0468 15.9755C25.2397 15.0055 25.1407 14.0002 24.7623 13.0866C24.3838 12.173 23.743 11.3921 22.9207 10.8427C22.0985 10.2932 21.1318 10 20.1429 10C18.8168 10 17.545 10.5268 16.6073 11.4645C15.6696 12.4021 15.1429 13.6739 15.1429 15Z",
    fill: "#6AC982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileButton);
export default __webpack_public_path__ + "static/media/profile-button.d7d30371f317da22acab70ce89f774c1.svg";
export { ForwardRef as ReactComponent };